import { Button } from "@common/index";
import styles from "./styles.module.scss";
import progress from "./img/progress.png";
import stats from "./img/stats.png";

export const StridersFoward = ({ onNextStep, onTrackEvent }) => {
  return (
    <div id="breakdown" className={styles.container}>
      <div className={styles.content}>
        <div className={styles.hints}>
          <h4>You're making strides towards your goal! </h4>
          <br />
          <img src={progress} alt="" />
          <br />
          <br />
          <img src={stats} alt="" />
          <br />
          <br />
          Our walking programs will seamlessly integrate with your fitness
          tracker.
        </div>
      </div>
      <Button
        variant="walky"
        onClick={() => {
          onNextStep();
          onTrackEvent();
        }}
      >
        Continue
      </Button>
    </div>
  );
};
